//
// features-service.ts
//
// Copyright (c) 2015 by Curalate, Inc.
//

((() => {
    const angular = window['angular'];
    type IPromise<T> = angular.IPromise<T>;

    angular.module('curalate').service('FeaturesService', ['FeaturesApiService',
        function (FeaturesApiService) {
            let featuresList = null;
            let clientFeaturesList = null;
            let clientsWithFeatureList = null;
            let clientChangelog = null;
            let lastStart: string = null;
            let lastEnd: string = null;
            let lastClient = '-1';
            let lastFeature = null;

            this.getFeaturesListAsync = force => {
                if (featuresList === null || force) {
                    featuresList = FeaturesApiService.asyncGetAllFeatures();
                }
                return featuresList;
            };

            this.getClientFeaturesListAsync = (client, force) => {
                if (clientFeaturesList === null || force || client !== lastClient) {
                    clientFeaturesList = FeaturesApiService.asyncGetAllClientFeatureDetails(client);
                    lastClient = client;
                }
                return clientFeaturesList;
            };

            this.getClientChangelogAsync = (
                client: string,
                start: string,
                end: string,
                force: boolean = false
            ): IPromise<Array<IClientFeatureChangeDTO>> => {
                if (!clientChangelog || force || client !== lastClient || start !== lastStart || end !== lastEnd) {
                    clientChangelog = FeaturesApiService.getClientFeatureChanges(client, start, end);
                    lastClient = client;
                    lastStart = start;
                    lastEnd = end;
                }
                return clientChangelog;
            };

            this.getClientsWithFeatureListAsync = (feature, force) => {
                if (clientsWithFeatureList === null || force || feature !== lastFeature) {
                    clientsWithFeatureList = FeaturesApiService.getClientsWithFeatureAsync(feature);
                    lastFeature = feature;
                }
                return clientsWithFeatureList;
            };
        },
    ]);
}))();
